<template lang="html">
  <b-col class="recommendation-text">
    <span class="reportLabel mt-0">Report Title</span>
    <span class="font-weight-bold">{{ recommendation.report }}</span>
    <span class="reportLabel">Institution</span>
    <span>{{recommendation.entity}}</span>
    <span class="reportLabel">Indicator</span>
    <span>{{recommendation.indicator}}</span>
    <span class="reportLabel">Recommendation</span>
    <span class="font-weight-bold recommendationText" v-html="recommendation.recommendation"></span>
    <div v-if="recommendation.url && recommendation.url.length" class="position-absolute reportUrl" style="bottom: 0">Link to report: <b-link target="_blank" :href="recommendation.url">{{recommendation.report}}</b-link>
    </div>
  </b-col>
</template>

<script>
export default {
  props: ['recommendation', 'showResponses', 'showFindings']
}
</script>

<style lang="css" scoped>
.reportUrl {
  width: 95%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.recommendation-text {
  padding-bottom: 2em;
}

.reportLabel {
  display: block;
  font-family: "Nunito", Arial, sans-serif;
  color: #223d6b;
  font-weight: bold;
  font-size: 0.8rem;
}
.recommendation-text .reportLabel {
  color: #b79d61;
  margin-top: 0.75em;
}
</style>
